/**
 * List all possible commands the system is capable of processing.
 */
export enum CommunicationWorkflowTargetTimeoutName {
  fixed = 'fixed',
}

export type CommunicationWorkflowTargetTimeoutNameType = keyof typeof CommunicationWorkflowTargetTimeoutName;
